import { END_CALL_EVENTS, END_CALL } from "../reducers/endCall-reducer";
import endCallService from "../services/endCallService";
import { LogFirebase } from "../services/firestore";
import { dispatchAction } from "../shared/function";

const endCallStart = () => dispatchAction(END_CALL_EVENTS.END_CALL, END_CALL.START);
const endCallSuccess = (data) => dispatchAction(END_CALL_EVENTS.END_CALL, END_CALL.SUCCESS, data);
const endCallError = (error) => dispatchAction(END_CALL_EVENTS.END_CALL, END_CALL.ERROR, error);

export const handleEndCallAPI = (req) => async (dispatch) => {
    dispatch(endCallStart());
    endCallService
        .endCallServiceFunction(req)
        .then((response) => {
            dispatch(endCallSuccess(response));
            LogFirebase("End_Call", "endCallData", {
                request: req,
                response: response,
            });
        })
        .catch((error) => {
            LogFirebase("End_Call", "endCallData", {
                error: error,
            });
            dispatch(endCallError(error));
        });
};
